<script>
  import { onDestroy } from 'svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import UserAccountFlagAjax from '@ajax/user_account_flag';

  import { getProfileStore } from '@stores/profile';
  let linktreePromptStore = getProfileStore('linktreePromptStore');
  import loadLinktree from '@utils/linktree';

  export let mobile = false;
  let currentUser = getCurrentUserStore('default');
  let show = false;
  let unsubLinktreeShow = linktreePromptStore.subscribe((x) => {
    show = x.social;
    if (show) {
      loadLinktree(currentUser.profile_path, 'benable_profile', '#linktree-social-button');
    }
  });

  let elem;

  let handleClick = function () {
    UserAccountFlagAjax.flagLinktreeProfilePromptClicked();
    linktreePromptStore.set({
      banner: false,
      social: false,
    });
    elem.querySelector('button').click();
  };

  onDestroy(async () => {
    unsubLinktreeShow();
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .linktree-social-prompt {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px;
    gap: 8px;
    margin-top: 15px;
    cursor: pointer;

    &.mobile {
      justify-content: left;
    }

    .text {
      color: $purple-50;
      @include typeface-b2($font-weight-semi-bold);
    }
  }
</style>

<div id="linktree-social-button" bind:this={elem} style="display: none" />

{#if currentUser && currentUser.id && show}
  <div on:click={handleClick} class="linktree-social-prompt" class:mobile={mobile}>
    <img
      width="12"
      height="12"
      class="icon"
      src="/images/save-button/plus.svg"
      alt="plus-icon"
      style="margin-right: 5px" />
    <span class="text">Add Benable to my Linktree</span>
  </div>
{/if}
